import { useRouterState } from "@tanstack/react-router";
import { useMemo } from "react";

import { APP_ROUTES } from "@/components/router/routes";

const routeTitles: Record<string, string> = {
    [APP_ROUTES.ROOT]: "sessions",
    [APP_ROUTES.PROFILE]: "profile",
    [APP_ROUTES.SETTINGS]: "settings",
    [APP_ROUTES.CLINICS]: "clinics",
    [APP_ROUTES.STAFF]: "staff",
    [APP_ROUTES.SHIFTS]: "shifts",
};

export const usePageTitle = () => {
    const routerState = useRouterState();
    const pathname = routerState.location.pathname;

    return useMemo(() => {
        return routeTitles[pathname] ?? "";
    }, [pathname]);
};
